import { Component } from '@angular/core';
import { StatementStatus } from '../../../businesses/models/statements.models';
import { StatementsFacade } from '../../../businesses/services/statements.facade';

import { Filter } from '@app/shared/models/filter';
import { SegmentEvent, SegmentIoService } from '@app/shared/services/segmentIo/segment-io.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  standalone: false,
  selector: 'hospitable-statements-dashboard',
  templateUrl: './statements-dashboard.component.html',
  styleUrls: ['./statements-dashboard.component.scss'],
})
export class StatementsDashboardComponent {
  activeFilters$: BehaviorSubject<Filter[]> = new BehaviorSubject<Filter[]>([]);

  constructor(
    private statementsService: StatementsFacade,
    private segment: SegmentIoService
  ) {
    this.statementsService.getStatements(StatementStatus.Draft);
    this.statementsService.getStatements(StatementStatus.InReview);
    this.statementsService.getStatements(StatementStatus.Published);
    this.statementsService.getStatements(StatementStatus.Paid);

    this.activeFilters$.subscribe((filters) => {
      this.statementsService.getStatements(StatementStatus.Draft, filters);
      this.statementsService.getStatements(StatementStatus.InReview, filters);
      this.statementsService.getStatements(StatementStatus.Published, filters);
      this.statementsService.getStatements(StatementStatus.Paid);
    });
  }

  onShareFeedbackClick() {
    this.segment.track(SegmentEvent.OwnerStatementShareFeedbackDashboard, {});
  }
}
